// extracted by mini-css-extract-plugin
export default {"item":"autocomplete_item-module__item--xHJGy","selected":"autocomplete_item-module__selected--DDSwQ","offset":"autocomplete_item-module__offset--3yRER"};